<template>
    <div>
        <img class="logo" src="../assets/logo.png">

        <section class="blk1 fz32">
            ျမန္မာႏုိငံရွိ လူမ်ားကို မည္သုိ႔ေခၚသနည္း။
        </section>

        <div class="formbox blk3">
<!--            <section>-->
<!--                <input class="input-block" v-model="mobile" type="number" name="mobile" placeholder="Insert MPT phone Number">-->
<!--            </section>-->
<!--            <section>-->
<!--                <input class="input-block" v-model="passwd" type="password" name="passwd" placeholder="Inster Your password">-->
<!--            </section>-->
            <section>
                <div class="btn btn-block" @click="go_cg">ဝင်မည်</div>
            </section>
        </div>

<!--        <section class="mt30">-->
<!--            <p class="mt10">Don't have Account? <a href="">Click here</a></p>-->
<!--            <p>Type QM send sms to 1234 </p>-->
<!--            <p class="mt20">Forget your password? <a href="">Click here</a></p>-->
<!--        </section>-->

        <Footer></Footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Footer from './Footer'
export default {
    name: 'Loin',
    components: {Footer},
    data(){
        return{
            mobile: '',
            passwd: ''
        }
    },
    computed: {
        ...mapState(['langMap','lang'])
    },
    methods: {
        go_cg(){
          window.location.href = "https://gt.questtomio.com/consent/page";
        },
        // 登录
        _loginAction(){
            let reqData = {mobile: this.mobile, password: this.passwd}
            Utils.$ajax({
                type: 'post',
                url: '/login/login',
                data: reqData,
            }).done(res=>{
                if(res.code==0){
                    localStorage.A_uuid = res.data.uuid;
                    localStorage.A_token = res.data.token;
                    this.$router.push('/Ucenter');
                }else if(res.code==4401){
                    window.location.href = "https://gt.questtomio.com/consent/page";
                }else{
                    this.$toast(res.msg);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .blk2{
        margin-top: rem(30);
        i{
            display: inline-block;
            width: 1.2em;
            line-height: 1.2em;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255,255,255,.3);
            vertical-align: middle;
            margin-right: .8em;
        }
    }
    .blk3{
        margin-top: rem(46);
        section{
            margin-top: rem(34);
            &:first-child{
                margin-top: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue